export default __webpack_public_path__ + "static/media/eye-icon.5576388b.svg";